import React, { useState } from 'react';
import '../../../../assets/css/admin/dashboardCSS/Notifications.css';
import Adminlayout from '../../../../layouts/admin/Adminlayout';

const Notifications = () => {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'request',
      icon: '📚',
      message: 'New help request from Ali Khan for university fee',
      name: 'Ali Khan',
      time: '2 minutes ago',
      isRead: false,
    },
    {
      id: 2,
      type: 'donation',
      icon: '💰',
      message: 'Ahmed Donor donated PKR 50,000 for student fees',
      name: 'Ahmed Donor',
      time: '15 minutes ago',
      isRead: false,
    },
    {
      id: 3,
      type: 'dispute',
      icon: '⚠️',
      message: 'New dispute raised by Usman Donor against Sara M.',
      name: 'Usman Donor',
      time: '1 hour ago',
      isRead: false,
    },
    {
      id: 4,
      type: 'warning',
      icon: '🔔',
      message: 'Student Hassan Ali has been warned for fake requests',
      name: 'System',
      time: '3 hours ago',
      isRead: true,
    },
    {
      id: 5,
      type: 'donation',
      icon: '💰',
      message: 'Fatima Donor donated books worth PKR 15,000',
      name: 'Fatima Donor',
      time: '5 hours ago',
      isRead: true,
    },
    {
      id: 6,
      type: 'info',
      icon: 'ℹ️',
      message: 'Monthly report is ready for review',
      name: 'System',
      time: '1 day ago',
      isRead: true,
    },
    {
      id: 7,
      type: 'request',
      icon: '📚',
      message: 'Urgent: Student needs uniform for school tomorrow',
      name: 'Zainab Ahmed',
      time: '2 days ago',
      isRead: true,
    },
  ]);

  const [filter, setFilter] = useState('all'); // all, unread, read

  // Count unread notifications
  const unreadCount = notifications.filter((n) => !n.isRead).length;

  // Mark single notification as read
  const markAsRead = (id) => {
    setNotifications(
      notifications.map((notif) =>
        notif.id === id ? { ...notif, isRead: true } : notif
      )
    );
  };

  // Mark all notifications as read
  const markAllAsRead = () => {
    setNotifications(
      notifications.map((notif) => ({ ...notif, isRead: true }))
    );
  };

  // Delete notification
  const deleteNotification = (id) => {
    setNotifications(notifications.filter((notif) => notif.id !== id));
  };

  // Get icon class based on notification type
  const getIconClass = (type) => {
    switch (type) {
      case 'request':
        return 'adn-icon-request';
      case 'donation':
        return 'adn-icon-donation';
      case 'dispute':
        return 'adn-icon-dispute';
      case 'warning':
        return 'adn-icon-warning';
      case 'info':
        return 'adn-icon-info';
      default:
        return 'adn-icon-info';
    }
  };

  // Filter notifications
  const filteredNotifications = notifications.filter((notif) => {
    if (filter === 'unread') return !notif.isRead;
    if (filter === 'read') return notif.isRead;
    return true;
  });

  return (
    <Adminlayout>

    <div className="adn-notifications-page">
      {/* Page Header */}
      <div className="adn-page-header">
        <div className="adn-header-content">
          <h1 className="adn-page-title">Notifications</h1>
          <p className="adn-page-subtitle">
            You have {unreadCount} unread notification{unreadCount !== 1 ? 's' : ''}
          </p>
        </div>
        {unreadCount > 0 && (
          <button className="adn-mark-all-btn" onClick={markAllAsRead}>
            Mark all as read
          </button>
        )}
      </div>

      {/* Filter Tabs */}
      <div className="adn-filter-tabs">
        <button
          className={`adn-filter-tab ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          All ({notifications.length})
        </button>
        <button
          className={`adn-filter-tab ${filter === 'unread' ? 'active' : ''}`}
          onClick={() => setFilter('unread')}
        >
          Unread ({unreadCount})
        </button>
        <button
          className={`adn-filter-tab ${filter === 'read' ? 'active' : ''}`}
          onClick={() => setFilter('read')}
        >
          Read ({notifications.length - unreadCount})
        </button>
      </div>

      {/* Notifications List */}
      <div className="adn-notifications-container">
        {filteredNotifications.length > 0 ? (
          filteredNotifications.map((notification) => (
            <div
              key={notification.id}
              className={`adn-notification-card ${
                !notification.isRead ? 'adn-unread-card' : ''
              }`}
            >
              <div
                className={`adn-notification-icon-circle ${getIconClass(
                  notification.type
                )}`}
              >
                {notification.icon}
              </div>

              <div className="adn-notification-body">
                <p className="adn-notification-message">{notification.message}</p>
                <div className="adn-notification-meta">
                  <span className="adn-notification-time">{notification.time}</span>
                  {!notification.isRead && (
                    <span className="adn-unread-badge">New</span>
                  )}
                </div>
              </div>

              <div className="adn-notification-actions">
                {!notification.isRead && (
                  <button
                    className="adn-action-btn adn-read-btn"
                    onClick={() => markAsRead(notification.id)}
                    title="Mark as read"
                  >
                    ✓
                  </button>
                )}
                <button
                  className="adn-action-btn adn-delete-btn"
                  onClick={() => deleteNotification(notification.id)}
                  title="Delete"
                >
                  🗑️
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="adn-empty-state">
            <div className="adn-empty-icon">🔔</div>
            <h3 className="adn-empty-title">No notifications</h3>
            <p className="adn-empty-text">
              {filter === 'unread'
                ? "You're all caught up! No unread notifications."
                : filter === 'read'
                ? 'No read notifications yet.'
                : 'You have no notifications at the moment.'}
            </p>
          </div>
        )}
      </div>
    </div>
    </Adminlayout>
  );
};

export default Notifications;